<template>
  <div>
    <v-dialog max-width="400" v-model="dialog">
      <v-card rounded="lg">
        <v-card-title class="justify-space-between align-start pb-0">
          <div>
            <h3 class="text-h6 font-weight-medium">Roll Up Item</h3>
            <p class="text-subtitle-2 text--secondary">
              Enter the details below and submit
            </p>
          </div>
        </v-card-title>

        <v-card-text>
          <p class="mb-0">
            Item: <strong> {{ item?.feeName }}</strong>
          </p>
          <p class="mb-0">
            Total flat fee:
            <strong>
              {{
                item.attractGct
                  ? item.flatFeeWithGct || 0
                  : item.flatFee || 0 | currency
              }}</strong
            >
          </p>
          <p class="mb-7">
            Total policy rate:
            <strong>
              {{
                item.attractGct ? item?.feeRatePercentageWithGct : item.feeRate
              }}%</strong
            >
          </p>
          <ValidationObserver ref="itemObserver">
            <v-row dense>
              <v-col cols="12">
                <ValidationProvider
                  name="Roll-up Percentage"
                  :rules="`required|min_value:0|max_value:${
                    item.attractGct
                      ? item.feeRatePercentageWithGct
                      : item.feeRate
                  }`"
                  events="['blur']"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    dense
                    type="number"
                    min="0"
                    max="100"
                    :disabled="item.feeRatePercentageWithGct === 0"
                    outlined
                    label="Roll-up Percentage*"
                    v-model.number="item.rollUpPercentage"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
              <v-col cols="12">
                <ValidationProvider
                  name="Roll-up amount"
                  :rules="`required|min_value:0|max_value:${
                    item.attractGct ? item.flatFeeWithGct : item.flatFee
                  }`"
                  events="['blur']"
                  v-slot="{ errors }"
                >
                  <v-text-field
                    dense
                    type="number"
                    min="0"
                    max="100"
                    :disabled="item.flatFee === 0"
                    outlined
                    label="Roll-up amount*"
                    v-model.number="item.rollUpAmount"
                    :error-messages="errors"
                  ></v-text-field>
                </ValidationProvider>
              </v-col>
            </v-row>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions class="pt-0 justify-end">
          <v-btn
            @click="closeModal()"
            min-width="120"
            depressed
            class="text-capitalize"
            >Cancel</v-btn
          >
          <v-btn
            @click="onSubmit()"
            min-width="120"
            depressed
            color="primary"
            class="text-capitalize"
            >Submit</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageMixin from '@/mixins/page.mixin';
export default {
  mixins: [PageMixin],
  data() {
    return {
      dialog: false,
      item: {}
    };
  },
  methods: {
    async closeModal() {
      this.dialog = false;
      this.item = {};
      await this.$refs.itemObserver?.reset();
    },
    open(item = {}) {
      this.item = item;
      this.dialog = true;
    },
    async onSubmit() {
      try {
        const valid = await this.$refs.itemObserver?.validate();
        if (!valid) return;
        this.$emit('itemSent', this.item);
        this.closeModal();
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>
